var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    _vm._g(
      _vm._b(
        {
          ref: _vm.data.ref,
          class: [_vm.data.class, _vm.data.staticClass],
          style: [_vm.data.style, _vm.data.staticStyle],
          attrs: {
            version: "1.1",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        "svg",
        _vm.data.attrs,
        false
      ),
      _vm.listeners
    ),
    [
      _c("g", { attrs: { fill: "none" } }, [
        _c("path", {
          attrs: { d: "M0,0h24v24h-24Z", transform: "translate(0, 0.007)" }
        })
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M4.293,6l1.414,1.414l3.707,-3.707l-3.707,-3.707l-1.414,1.414l1.293,1.293h-5.586v2h5.586Z",
            transform: "translate(8, 5.294)"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M5.121,6l-1.293,-1.293h5.586v-2h-5.586l1.293,-1.293l-1.414,-1.414l-3.707,3.707l3.707,3.707Z",
            transform: "translate(6.586, 11.294)"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M18,0h-16c-1.104,0 -2,0.896 -2,2v16c0,1.102 0.896,2 2,2h16c1.104,0 2,-0.898 2,-2v-16c0,-1.104 -0.896,-2 -2,-2Zm-0.003,18h-15.997v-16h16l-0.003,16Z",
            transform: "translate(2, 2.001)"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }